export default "__VITE_ASSET__BL4Q7JtH__"